// personalised-metafield-injector.js

(function () {
  'use strict';

  const PREGNANCY_KEY = 'vitable_pregnancy';
  const ALLERGY_KEY = 'vitable_allergy';
  const NAME_ON_PACK_KEY = 'vitable_name_on_pack';
  const QUIZ_DATE_KEY = 'vitable_latest_quiz_date';

  /**
   * Sync metafields to localStorage if present
   * These values are injected into the page via Liquid
   */
  function syncMetafieldsIfLoggedIn() {
    try {
      const pregnancy = window.__vitableMetafields?.pregnancy;
      const allergy = window.__vitableMetafields?.allergy;
      const nameOnPack = window.__vitableMetafields?.name_on_pack;
      const latestQuizDate = window.__vitableMetafields?.latest_quiz_date;

      if (pregnancy) {
        localStorage.setItem(PREGNANCY_KEY, pregnancy);
        console.log('[Metafield Injector] Set pregnancy:', pregnancy);
      }

      if (allergy) {
        localStorage.setItem(ALLERGY_KEY, allergy);
        console.log('[Metafield Injector] Set allergy:', allergy);
      }
      
      if (nameOnPack) {
        localStorage.setItem(NAME_ON_PACK_KEY, nameOnPack);
        console.log('[Metafield Injector] Set name_on_pack:', nameOnPack);
      }
      
      if (latestQuizDate) {
        localStorage.setItem(QUIZ_DATE_KEY, latestQuizDate);
        console.log('[Metafield Injector] Set latest_quiz_date:', latestQuizDate);
      }
    } catch (err) {
      console.error('[Metafield Injector] Error syncing metafields:', err);
    }
  }

  /**
   * Remove metafield keys from localStorage if user not logged in
   */
  function clearMetafieldsIfGuest() {
    [PREGNANCY_KEY, ALLERGY_KEY].forEach((key) => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
        console.log(`[Metafield Injector] Removed ${key} (user not logged in)`);
      }
    });
  }

/**
 * Clear quiz values (pregnancy, allergy, name_on_pack) from localStorage
 * Should be called before syncing metafields on login to prevent data persistence between users
 */
function clearQuizValues() {
  try {
    localStorage.removeItem(PREGNANCY_KEY);
    localStorage.removeItem(ALLERGY_KEY);
    localStorage.removeItem(NAME_ON_PACK_KEY);
    localStorage.removeItem(QUIZ_DATE_KEY);
    console.log('[Metafield Injector] Cleared quiz values before syncing metafields');
  } catch (err) {
    console.error('[Metafield Injector] Error clearing quiz values:', err);
  }
}

/**
 * Entry point — choose mode based on data injected via Liquid
 * Only syncs metafields for logged-in users
 * Logout clearing is handled by the login state change event system
 */
function runMetafieldInjector() {
  const loggedIn = window.__vitableMetafields?.loggedIn === true;

  if (loggedIn) {
    // First clear existing quiz values to prevent stale data between users
    clearQuizValues();
    // Then sync metafields from the current logged-in user
    syncMetafieldsIfLoggedIn();
  }
  // Do nothing for guest users - preserve quiz data
}  // Auto-run immediately
  runMetafieldInjector();

})();
